import { useState } from 'react'
import styles from './styles.module.css'
import StepEmail from './stepEmail'
import StepVerifyEmail from './stepVerifyEmail'
import StepPassword from './stepPassword'
import { SignInAnimation } from '../../components/SignInAnimation'
import { motion } from 'framer-motion'

const STEPS = {
  STEP_PASS_EMAIL: 'stepEmail',
  STEP_VERIFY_EMAIL: 'stepVerifyEmail',
  STEP_PASS_PASSWORD: 'stepPassword',
}

function ForgotPassword() {
  const [step, setStep] = useState(STEPS.STEP_PASS_EMAIL)

  const [email, setEmail] = useState('')
  const [code, setCode] = useState('')

  const [pass, setPass] = useState('')
  const [confirmPass, setConfirmPass] = useState('')

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.3 }}
      className={styles.page}
    >
      <div className={styles.sign_in_field}>
        <div className={styles.sign_box}>
          <SignInAnimation />
        </div>

        <div className={styles.sign_box_login}>
          <div className={styles.container_content}>
            {step === STEPS.STEP_PASS_EMAIL && (
              <StepEmail setEmail={setEmail} email={email} setStep={setStep} />
            )}

            {step === STEPS.STEP_VERIFY_EMAIL && (
              <StepVerifyEmail
                setEmail={setEmail}
                email={email}
                setStep={setStep}
                setCode={setCode}
                code={code}
              />
            )}

            {step === STEPS.STEP_PASS_PASSWORD && (
              <StepPassword
                setPass={setPass}
                setConfirmPass={setConfirmPass}
                pass={pass}
                confirmPass={confirmPass}
                setStep={setStep}
                email={email}
                code={code}
              />
            )}
          </div>
        </div>
      </div>
    </motion.div>
  )
}

export default ForgotPassword
